import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// material-ui
import { ButtonBase } from "@mui/material";

// project imports
import { MENU_OPEN } from "../../store/actions";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({width=82,height=40}:{width?:number,height?:number}) => {
  const defaultId = useSelector((state: any) => state.customization.defaultId);
  const dispatch = useDispatch();
  return (
    <ButtonBase
      disableRipple
      onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })}
      component={Link}
      to={"/dashboard"}
    >
      <img
        src="/assets/images/mabzoneLogo.svg"
        alt="mabzone"
        width={width}
        height={height}
      />
    </ButtonBase>
  );
};

export default LogoSection;
